jQuery(function(){

	jQuery.fn.extend({
		toggleText:function(a,b){
			if(this.html()==a){this.html(b)}
			else{this.html(a)}
		}
	});
    
	jQuery('.mob-nav li.toggle').click(function() {
		jQuery(this).find('ul').slideToggle(200);
		jQuery(this).find('em').toggleText('+','–');
	});
	
	jQuery('.mob-nav li.toggle li.on:first').closest('li.toggle').addClass('on');
    
    jQuery('.mob-header .hamburger').click(function() {
        jQuery('.mob-header .hamburger').toggleClass('hamburger-active');
		jQuery('.mob-nav').fadeToggle(150);
		jQuery('body').toggleClass('noscroll');
	});
    
	jQuery(window).scroll(function () {

		if(jQuery(window).scrollTop()>1) {
			jQuery('.page-header').addClass('page-header-on');
		}else{
			jQuery('.page-header').removeClass('page-header-on');
		}
		
     });
	
})